import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { base64Logic } from "../../Shared/common_logic";
import { GSTActions } from '../../Actions';
import Loader from '../../Components/Loader/Loader';
import './GST.css'

class GST extends Component {
    state = {
        options: [],
        showOtp: false,
        username: "",
        gstin: "",
        password: "",
        successMsg: "",
        checkError: {},
        otp: ''
    }

    componentWillMount() {
        const { history } = this.props;
        let base64_decode;
        let errors = {};
        
        let params = new URLSearchParams(history.location.search);
        let payload = params.get('payload');

        if (payload) {
            base64_decode = base64Logic(payload, "decode");
            errors['payload_missing'] = "";
        } else {
            errors['payload_missing'] = "Payload Missing";
        }

        if (Object.values(errors).some(e => e !== "")) {
            this.setState({ checkError: errors });
        }
        this.setState({ payload: base64_decode })
    }

    componentDidMount() {
        const { payload } = this.state;
        const errors = {}

        if (payload && (payload.loan_application_id === undefined || payload.loan_application_id.length === "")) {
            errors['loan_application_id'] = "loan application id is required";
        } else {
            errors['loan_application_id'] = "";
        }

        if (payload && (payload.app_id === undefined || payload.app_id.length === "")) {
            errors['app_id'] = "App Id is required";
        } else {
            errors['app_id'] = "";
        }
        if (Object.values(errors).some(er => er !== "")) {
            this.setState({ checkError: errors })
            return;
        }
        this.props.postFetchMutipleGST({
            app_id: payload.app_id,
            loan_application_id: payload.loan_application_id
        })
    }

    handleChange = selectedOption => {
        this.setState({ gstin: selectedOption });
    };

    generateOTP = () => {
        const { gstin, username, payload, showOtp,password } = this.state;
        const errors = {}

        this.setState({ otp: "" })

        if (gstin === "") {
            errors['gstin'] = "Select Gstin";
        } else {
            errors['gstin'] = "";
        }

        if (username.length === 0) {
            errors['username'] = "Username is required";
        } else {
            errors['username'] = "";
        }

        if (password.length === 0) {
            errors['password'] = "Password is required";
        } else {
            errors['password'] = "";
        }

        if (Object.values(errors).some(er => er !== "")) {
            this.setState({ checkError: errors })
            return;
        }
        if (gstin.value.length && username.length) {

            this.props.postOTPGeneration({
                app_id: payload.app_id,
                loan_application_id: payload.loan_application_id,
                username,
                password,
                gstin: gstin.value.split('-')[0].trim()
            })

        }
            
        //this.setState({ showOtp: !showOtp })
    }

    async UNSAFE_componentWillReceiveProps(nextProps) {
        const { Gst } = nextProps;

        const nextGst = await Gst.result && Gst.result.data && Gst.result.data.attributes;
        if (!!nextGst) {
            const gstOptions = nextGst.gstins.map(gst => ({
                label: gst.gstin + ' - ' + gst.state,
                value: gst.gstin + ' - ' + gst.state
            }))
            this.setState({ options: gstOptions })
        }

        if(Gst && Gst.postResult && Gst.postResult.data && Gst.postResult.data.status && Gst.postResult.data.status === "success") {
            var that = this;
            this.setState({ showOtp: true, successMsg: Gst.postResult.data.message})
            setTimeout(function() {
                that.setState({ successMsg: ""})
            }, 3000);
        }
    }

    submitGST = () => {
        const { gstin, username, payload, otp, showOtp } = this.state;
        const errors = {}

        if (gstin === "") {
            errors['gstin'] = "Select Gstin";
        } else {
            errors['gstin'] = "";
        }

        if (username.length === 0) {
            errors['username'] = "Username is required";
        } else {
            errors['username'] = "";
        }

        if (otp.length === 0) {
            errors[otp] = "Otp  is required";
        } else {
            errors[otp] = "";
        }

        if (Object.values(errors).some(er => er !== "")) {
            this.setState({ checkError: errors })
            return;
        }
        if (gstin.value.length && username.length && otp.length)
            this.props.postGSTData({
                app_id: payload.app_id,
                loan_application_id: payload.loan_application_id,
                username,
                gstin: gstin.value.split('-')[0].trim(),
                request_id: this.props.Gst.postResult.data.request_id,
                otp: otp
            })
        this.setState({ checkError: {} })
    }

    initialPage = e => {
        e.preventDefault();
        window.location = window.location.href;
    }

    render() {
        const { Gst } = this.props;
        const { gstin, options, payload, showOtp, checkError, username, password, otp } = this.state;
        const checkGstSuccess = Gst && Gst.GSTResult && Gst.GSTResult.data && Gst.GSTResult.data.status;
        const checkGstOTPLoading = Gst && Gst.postloading;

        const checkGstErrorStatus = Gst && Gst.GSTError && 'error' in Gst.GSTError && Gst.GSTError.error.data && Gst.GSTError.error.data.status;
        const checkGstError = Gst && Gst.GSTError && Gst.GSTError.data !== undefined && Gst.GSTError.data.status;
        const showGst = checkGstSuccess !== "success" && (Gst.GSTloading === undefined || Gst.GSTloading === true) ? false : true;
        
        return (
            <div className="container-fluid padd0 container-ffluid">
                <div className="row container-ffluid-row">
                {
                    !showGst && <div className="col-md-12 paddingZZero"><Loader textLoading={true} /></div>
                }
                {showGst && checkGstSuccess !== "success" ?
                    <>
                        <div className="col-md-12 d-flex pl-5">
                            <div className="col-md-6 p-0">
                                <img src="https://mintifi.com/media/logo.png" alt="logo" className="pt-4 mb-4" />
                            </div>
                        </div>                
                        <div className="col-md-12">
                            <div>
                                <div className="text-center">
                                    <span><span className="heading itrColor">GST </span><label className="heading">Details Submission</label></span>
                                </div>
                                <div className="text-content">
                                    <p className="mb-0">You are about the submit GST details of your business with Mintifi Private Limited.</p>
                                    <p className="mb-0">Your data is protected with the highest standards and will be shared across </p>
                                    <p>lenders associated with your loan application <strong className="text-id">ID - {payload && payload.loan_application_id}</strong></p>
                                </div>
                            </div>
                            {
                                checkError && Object.keys(checkError) && Object.keys(checkError).map(err => {
                                    return (
                                        <div key={err} style={{ textAlign: 'center' }}>
                                            {
                                                checkError[err].length > 0 ?
                                                    <div key={`mintifi_${err}`}>
                                                        <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                                            {checkError[err]}
                                                        </span>
                                                    </div> : null
                                            }
                                        </div>
                                    )
                                })
                            }
                            {this.state.successMsg &&
                                <div className="text-center">
                                <span className="col-md-4 m-auto" style={{ color: "green", fontSize: "16px" }}>
                                    {this.state.successMsg}
                                </span>
                                </div>
                            }
                            {Gst && Object.keys(Gst).length && 'GSTError' in Gst && Gst.GSTError.errors !== undefined && Gst.GSTError.errors.length ? Gst.GSTError.errors.map(err => {
                                return (
                                    <div style={{ textAlign: 'center' }}>
                                        {
                                            <div key={`mintifi_${err.code}`}>
                                                <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                                    {err.code === "ER-AUTH-102" ? err.detail : err.code === "ER-AUTH-103" ? err.detail : err.code === "ER-GEN-202" ? err.detail : ""}
                                                </span>
                                            </div>
                                        }
                                    </div>
                                )
                            }) : null}
                            {Gst && Gst.postError  && Gst.postError.error && Gst.postError.error.data && Gst.postError.error.data.message ?
                                    <div style={{ textAlign: 'center' }}>
                                            <div>
                                                <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                                    {Gst.postError.error.data.message}
                                                </span>
                                            </div>
                                    </div>
                            : null}
                            {
                                Gst.GSTError && Gst.GSTError.status !== undefined ? <div className="col-md-12 d-flex" style={{ position: 'absolute', top: '26%', textAlign: 'center' }}>
                                    <div className="col-md-4 m-auto">
                                        <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                            {Gst.GSTError.error.data.message}
                                        </span>
                                    </div></div> : null
                            }
                            <div className="col-md-12 paddingZZero">
                                <div className="mrgn80">
                                    <div className="col-md-3 m-auto">
                                        <div className="row">
                                            <div className="col-md-12" >
                                            <p className="mb-0 labelText mt-3">GSTIN<span className="red">*</span></p>
                                            <Select
                                                value={gstin}
                                                onChange={this.handleChange}
                                                options={options}
                                                disabled={showOtp}
                                            />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 m-auto padd0">
                                        <p className="mb-0 labelText mb-2 mt-5">GSTN Username<span className="red">*</span></p>
                                        <input type="text" placeholder="Enter Username" className="col-md-12 gstUserInput" onChange={event => this.setState({ username: event.target.value })} value={username} disabled={showOtp} />
                                    </div>
                                    <div className="col-md-3 m-auto padd0">
                                        <p className="mb-0 labelText mb-2 mt-5">GSTN password<span className="red">*</span></p>
                                        <input type="text" placeholder="Enter password" className="col-md-12 gstUserInput" onChange={event => this.setState({ password: event.target.value })} value={password} disabled={showOtp} />
                                    </div>
                                    <div className="col-md-3 m-auto padd0">
                                        {
                                            showOtp === false ?
                                                <>
                                                    <div className="col-md-12 mt-3 mb-3 d-flex sub-btn">
                                                            <div className="col-md-4 m-auto padd0">
                                                                <div className="col-md-12 pull-right grid">
                                                            <button type="button" className="gstBtnSubmit float-right pl-3 pr-3"
                                                            disabled={Gst.postloading}
                                                             onClick={this.generateOTP}>{Gst.postloading ? "Loading..." : "Get OTP"}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <p className="mb-0 mt-5 labelText mb-2">OTP<span className="red">*</span></p>
                                                    <div className="d-flex">
                                                        <div className="col-md-12 p-0 FlexNone">
                                                            <input type="text" placeholder="Enter OTP" onChange={event => this.setState({ otp: event.target.value })} value={otp} className="col-md-12 gstPassInput" />
                                                        </div>
                                                    </div>
                                                </>
                                        }
                                        {showOtp === true &&
                                        <span className="float-right" disabled={checkGstOTPLoading}> <img src="/images/info.png" alt="ey" className="mr-1" width="13px" /><span onClick={() => this.generateOTP()} className="password-rules">Resend OTP</span></span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showOtp === true &&
                            <div className="col-md-12 mt-3 mb-3 d-flex sub-btn">
                                <div className="col-md-4 m-auto">
                                    <div className="col-md-12 pull-right grid">
                                    <button type="button" disabled={checkGstOTPLoading} className="gstBtnSubmit float-right pl-3 pr-3" onClick={this.submitGST}>Submit <img src="/images/arrow.png" alt="icon" className="ml-4 mb-1 dispNone" /></button>
                                    </div>
                                </div>
                            </div>
                        }
                    </> : null
                }

                {/* ---------------------------------------------------- */}
                {console.log(checkGstSuccess ,showGst, Gst.GSTloading,"sdfdfdf")}
                {
                    (checkGstSuccess === "success" && Gst.GSTloading === false) ?
                        <>
                            <div className="d-flex justify-content-center gstProcessing">                
                                    <div className="col-md-12 mrgn52 pl-0 pr-0">
                                        <div>
                                            <h2 className="process-inner-text" style={{fontSize: '18px'}}>We have received your request for App ID: <span style={{color: '#33373E'}}>{payload && payload.loan_application_id}</span> on <span style={{color: '#33373E'}}>{new Date().toLocaleString()}.</span><br/>We will get back you shortly.</h2>
                                        </div>
                                        <div className=" mt-5">
                                            <div className="text-center mb-5">
                                                <img src="/images/message_process.png" alt="message" style={{ height: "140px", width: "140px" }} />
                                            </div>
                                            <div className="text-center mb-3">
                                                <a className="addText" style={{ color: "white" }} onClick={this.initialPage}>Add Another GST</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </> : null
                }

                {/* ---------------------------------------------------- */}

                {
                    (checkGstError === "error" || checkGstErrorStatus === "error") && Gst.GSTError.status !== 422 && showGst === false && Gst.GSTloading === false ?
                        <>
                            <div className="col-md-12 mrgn52">
                                <div>
                                    <h2 className="something-wrong-text">Something went wrong</h2>
                                    <p className="something-wrong-inner-text">Please try again later</p>
                                </div>
                                <div className="col-md-12 mt-5">
                                    <div className="text-center mb-5">
                                        <img src="/images/eror message.png" alt="error" className="imgWidth" style={{ height: 253 }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mt-3 d-flex padd0 sub-btn">
                                <div className="col-md-3 paddlr20 cntr m-auto grid padd0">
                                    <button type="button" className="gstBtnSubmit pl-3 pr-3" onClick={this.initialPage}>Retry <img src="/images/arrow.png" alt="icon" className="ml-4 mb-1 dispNone" /></button>
                                </div>
                            </div>
                        </> : null
                }
            </div>
            </div>
        )
    }
}

function mapState(state) {
    const { Gst } = state;
    return { Gst };
}

const actionCreators = {
    postOTPGeneration: GSTActions.postOTPGeneration,
    postFetchMutipleGST: GSTActions.postFetchMutipleGST,
    postGSTData: GSTActions.postGSTData,
    // storeOldGstin: GSTActions.storeOldGstin
};

export default connect(mapState, actionCreators)(GST);